'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _immutable = require('immutable');

var _invariant = require('react-utils/invariant');

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
*  StepConfigInterface
*  ---
*  This interface is intended to do 3 things:
*
*    1. Standardize on how we build step flows
*    2. Provide sane defaults for step config options
*    3. Provide invariant type checking on required step config options
*/

var _doInvariantCheck = function _doInvariantCheck() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      key = _ref.key,
      value = _ref.value,
      expectedType = _ref.expectedType;

  var actualType = typeof value === 'undefined' ? 'undefined' : _typeof(value);

  (0, _invariant2.default)(value && actualType === expectedType, 'Step config error: required property "%s" expected to exist and be of type "%s". Received type: "%s"', key, expectedType, actualType);
};

var StepConfigInterface = function () {
  function StepConfigInterface() {
    _classCallCheck(this, StepConfigInterface);

    this._steps = new _immutable.OrderedMap({});

    // Returns this to make object instantiation chainable (cascade pattern)
    return this;
  }

  _createClass(StepConfigInterface, [{
    key: 'getSteps',
    value: function getSteps() {
      return this._steps;
    }
  }, {
    key: 'addStep',
    value: function addStep() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          route = _ref2.route,
          handler = _ref2.handler,
          _ref2$props = _ref2.props,
          props = _ref2$props === undefined ? {} : _ref2$props,
          _ref2$expandedWidth = _ref2.expandedWidth,
          expandedWidth = _ref2$expandedWidth === undefined ? false : _ref2$expandedWidth,
          _ref2$allowsRedirect = _ref2.allowsRedirect,
          allowsRedirect = _ref2$allowsRedirect === undefined ? false : _ref2$allowsRedirect,
          stepNumber = _ref2.stepNumber;

      _doInvariantCheck({
        key: 'route',
        value: route,
        expectedType: 'string'
      });

      _doInvariantCheck({
        key: 'handler',
        value: handler,
        expectedType: 'function'
      });

      var stepConfig = {
        handler: handler,
        props: props,
        expandedWidth: expandedWidth,
        allowsRedirect: allowsRedirect,
        stepNumber: stepNumber
      };

      this._steps = this._steps.set(route, stepConfig);

      // Returns this to make method chainable (cascade pattern)
      return this;
    }
  }]);

  return StepConfigInterface;
}();

exports.default = StepConfigInterface;
module.exports = exports['default'];